import {MRT_Localization_AR} from "material-react-table/locales/ar";
import {MRT_Localization_DE} from "material-react-table/locales/de";
import {MRT_Localization_ES} from "material-react-table/locales/es";
import {MRT_Localization_FR} from "material-react-table/locales/fr";
import {MRT_Localization_IT} from "material-react-table/locales/it";
import {MRT_Localization_PT} from "material-react-table/locales/pt";
import {ODATA_COLUMN_TYPES} from "../../utils/odata";

export const FLAT_TABLE_PROPS = Object.freeze({
  manualSorting: true,
  manualFiltering: true,
  manualPagination: true,
  layoutMode: "grid",
  enableStickyHeader: true,
  enableStickyFooter: true,
  enableDensityToggle: false,
  enableFullScreenToggle: false,
  enableRowVirtualization: true,
  enableColumnVirtualization: true,
  enableColumnResizing: true,
  enableColumnOrdering: true,
  enableColumnDragging: true,
  enableColumnPinning: true,
  paginationDisplayMode: "pages",
  muiPaginationProps: {
    className: "material-react-table__pagination",
    showRowsPerPage: false,
    size: "small",
    sx: {
      "& .MuiPaginationItem-text": {
        fontSize: "13px"
      }
    }
  },
  muiTablePaperProps: {
    className: "material-react-table__wrapper",
    elevation: 0,
    sx: {
      width: "100%",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      padding: "0 16px"
    }
  },
  muiTableContainerProps: {
    className: "material-react-table__table",
    sx: {
      scrollbarWidth: "thin",
      maxHeight: "100%",
      height: "100%",
      flex: 1,
      border: "1px solid rgba(0, 0, 0, .12)"
    }
  },
  muiTableHeadProps: {
    className: "material-react-table__table__head",
    sx: {
      opacity: 1
    }
  },
  muiTableHeadRowProps: {
    className: "material-react-table__table__head__row",
    sx: {
      boxShadow: "none",
      borderBottom: "1px solid rgba(0, 0, 0, .12)",
      backgroundColor: "#eee"
    }
  },
  muiTableHeadCellProps: {
    className: "material-react-table__table__head__cell",
    sx: {
      alignItems: "flex-start",
      fontSize: "13px",
      padding: "2px 8px",
      fontWeight: "500",

      "& .Mui-TableHeadCell-Content": {
        alignItems: "flex-start",
        height: "100%",

        "& .Mui-TableHeadCell-Content-Labels": {
          alignItems: "flex-start",
          marginTop: "2px",

          "& .MuiBadge-root": {
            marginTop: "2px"
          }
        },

        "& .Mui-TableHeadCell-ResizeHandle-Wrapper": {
          height: "100%",
          "& .MuiDivider-vertical": {
            height: "100%",
            top: "2px",
            borderWidth: "1px"
          }
        }
      },

      "& .MuiInputBase-formControl": {
        fontSize: "13px"
      }
    }
  },
  muiTableBodyProps: {
    className: "material-react-table__table__body"
  },
  muiTableBodyRowProps: {
    className: "material-react-table__table__body__row",
    sx: {
      "&:hover > td > div": {
        backgroundColor: "#eeeeee"
      }
    }
  },
  muiTableBodyCellProps: {
    className: "material-react-table__table__body__cell"
  },
  muiBottomToolbarProps: {
    className: "material-react-table__bottom-toolbar",
    sx: {
      alignItems: "center",
      boxShadow: "none",
      "& > div > div": {
        height: "100%"
      },
      "& .MuiTablePagination-root": {
        padding: 0
      },
      "& .MuiTablePagination-root > div > label.MuiFormLabel-root": {
        fontSize: "14px"
      },
      "& .MuiTablePagination-root > div > div.MuiInputBase-root": {
        fontSize: "14px"
      }
    }
  }
});

export const FLAT_TABLE_NO_INTERACTION_PROPS = Object.freeze({
  enableColumnActions: false,
  enableSorting: false,
  enableColumnDragging: false,
  enableColumnOrdering: false,
  enableColumnPinning: false,
  enableFilters: false,
  enableHiding: false
});

export const PAGE_SIZE_LIST = [25, 50, 100, 250, 500];
export const DEFAULT_PAGE_SIZE = 100;

export const COLUMN_TYPES = {
  measure: ODATA_COLUMN_TYPES.measure,
  territorial: ODATA_COLUMN_TYPES.territorial,
  dimension: ODATA_COLUMN_TYPES.dimension,
  image: ODATA_COLUMN_TYPES.image,
  addr: ODATA_COLUMN_TYPES.addr,
  lat: ODATA_COLUMN_TYPES.lat,
  lon: ODATA_COLUMN_TYPES.lon,
  website: ODATA_COLUMN_TYPES.website,
  phone: ODATA_COLUMN_TYPES.phone,
  note: ODATA_COLUMN_TYPES.note,
  mail: ODATA_COLUMN_TYPES.mail,
  coordinates: ODATA_COLUMN_TYPES.coordinates,
  dateTime: ODATA_COLUMN_TYPES.dateTime,
  time: ODATA_COLUMN_TYPES.time,
  day: ODATA_COLUMN_TYPES.day,
  month: ODATA_COLUMN_TYPES.month,
  year: ODATA_COLUMN_TYPES.year,
  quarter: ODATA_COLUMN_TYPES.quarter,
  quadrimester: ODATA_COLUMN_TYPES.quadrimester,
  semester: ODATA_COLUMN_TYPES.semester,
  identifier: ODATA_COLUMN_TYPES.identifier
};

export const TABLE_LANGUAGES = {
  ar: MRT_Localization_AR,
  de: MRT_Localization_DE,
  es: MRT_Localization_ES,
  fr: MRT_Localization_FR,
  it: MRT_Localization_IT,
  pt: MRT_Localization_PT
};

export const TABLE_CARD_STYLE = {
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
};

export const CSV_EXPORT_MODES = Object.freeze({
  full: "full",
  filtered: "filtered"
});
